import React from 'react';
import PropTypes from 'prop-types';
import { designSystem } from '@yola/ws-ui';

const { Heading, Paragraph, ActionButton, Icon, Stack, NotificationMessage } = designSystem;

const EmailVerification = ({
  captions,
  isLoading = false,
  notification = null,
  onVerifyEmailClick,
}) => (
  <Stack gap="spacing-s">
    {notification && !isLoading && (
      <NotificationMessage
        align="center"
        appearance={notification.appearance}
        title={notification.text}
      />
    )}
    <div className="ws-email-verification">
      <Icon glyph="mail-check" type="accent" size={64} />
      <Stack gap="spacing-4-xs">
        <Heading type="heading-5" align="center">
          {captions.title}
        </Heading>
        <Paragraph align="center">{captions.description}</Paragraph>
      </Stack>
      <Paragraph align="center">{captions.cta}</Paragraph>
      <ActionButton
        format="solid"
        size="large"
        appearance="accent"
        label={captions.button}
        isLoading={isLoading}
        onClick={onVerifyEmailClick}
      />
    </div>
  </Stack>
);

EmailVerification.propTypes = {
  captions: PropTypes.shape({
    title: PropTypes.string,
    description: PropTypes.string,
    cta: PropTypes.string,
    button: PropTypes.string,
  }).isRequired,
  isLoading: PropTypes.bool,
  notification: PropTypes.oneOfType([
    PropTypes.shape({
      appearance: PropTypes.string,
      text: PropTypes.string,
    }),
    PropTypes.oneOf([null]),
  ]),
  onVerifyEmailClick: PropTypes.func.isRequired,
};

export default EmailVerification;
